"use client";

import { c as _c } from "react/compiler-runtime";
import { useServices } from "../services-context";
import { ServiceCard, ServiceCardProps } from "@/app/[tenant]/self-schedule/components/self-schedule-card";
import { usePatientVerification } from "@/hooks/self-schedule/use-patient-verification";
import { PublicServiceDetail } from "@/types/service";
interface ServicesGridProps {
  services: PublicServiceDetail[];
  selectedCategory: string;
  isServiceSelected: (serviceId: string) => boolean;
  getServiceInstanceCount?: (serviceId: string) => number;
  isServiceUnavailable?: (serviceId: string) => boolean;
  canSelectMore: boolean;
  selectedCount: number;
  onServiceClick: (serviceId: string) => void;
  onQuantityChange: (serviceId: string, quantity: number) => void;
  maxQuantity: number;
  onInfoClick: ServiceCardProps["onInfoClick"];
}
export const ServicesGrid = t0 => {
  const $ = _c(31);
  const {
    services,
    selectedCategory,
    isServiceSelected,
    getServiceInstanceCount,
    isServiceUnavailable,
    canSelectMore,
    selectedCount,
    onServiceClick,
    onQuantityChange,
    maxQuantity,
    onInfoClick
  } = t0;
  const showDuration = useServices().state.data?.showServiceDuration !== false;
  const {
    blockingAppointment
  } = usePatientVerification();
  const length = services.length;
  let t1;
  if ($[0] !== blockingAppointment || $[1] !== canSelectMore || $[2] !== getServiceInstanceCount || $[3] !== isServiceSelected || $[4] !== isServiceUnavailable || $[5] !== length || $[6] !== maxQuantity || $[7] !== onInfoClick || $[8] !== onQuantityChange || $[9] !== onServiceClick || $[10] !== selectedCategory || $[11] !== selectedCount || $[12] !== services || $[13] !== showDuration) {
    let t2;
    if ($[15] !== blockingAppointment || $[16] !== canSelectMore || $[17] !== getServiceInstanceCount || $[18] !== isServiceSelected || $[19] !== isServiceUnavailable || $[20] !== length || $[21] !== maxQuantity || $[22] !== onInfoClick || $[23] !== onQuantityChange || $[24] !== onServiceClick || $[25] !== selectedCategory || $[26] !== selectedCount || $[27] !== showDuration) {
      t2 = (service, index) => {
        const isSelected = isServiceSelected(service.id);
        const selectionCount = getServiceInstanceCount?.(service.id) ?? 0;
        const remaining = Math.max(0, maxQuantity - selectedCount);
        const serviceMaxQuantity = service.allowMultipleBookings ? selectionCount + remaining : selectionCount;
        const disabled = !!blockingAppointment || !isSelected && !service.onlyBookableOverThePhone && (!canSelectMore || !!isServiceUnavailable?.(service.id));
        return <ServiceCard key={service.id + selectedCategory} service={service} isSelected={isSelected} selectionCount={selectionCount} disabled={disabled} maxQuantity={serviceMaxQuantity} onServiceClick={onServiceClick} onQuantityChange={onQuantityChange} onInfoClick={onInfoClick} showDuration={showDuration} animationDelay={300 / length * index} />;
      };
      $[15] = blockingAppointment;
      $[16] = canSelectMore;
      $[17] = getServiceInstanceCount;
      $[18] = isServiceSelected;
      $[19] = isServiceUnavailable;
      $[20] = length;
      $[21] = maxQuantity;
      $[22] = onInfoClick;
      $[23] = onQuantityChange;
      $[24] = onServiceClick;
      $[25] = selectedCategory;
      $[26] = selectedCount;
      $[27] = showDuration;
      $[28] = t2;
    } else {
      t2 = $[28];
    }
    t1 = services.map(t2);
    $[0] = blockingAppointment;
    $[1] = canSelectMore;
    $[2] = getServiceInstanceCount;
    $[3] = isServiceSelected;
    $[4] = isServiceUnavailable;
    $[5] = length;
    $[6] = maxQuantity;
    $[7] = onInfoClick;
    $[8] = onQuantityChange;
    $[9] = onServiceClick;
    $[10] = selectedCategory;
    $[11] = selectedCount;
    $[12] = services;
    $[13] = showDuration;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[29] !== t1) {
    t2 = <div className="mt-2 grid grid-cols-2 gap-4 md:grid-cols-3">{t1}</div>;
    $[29] = t1;
    $[30] = t2;
  } else {
    t2 = $[30];
  }
  return t2;
};
export default ServicesGrid;